@if(details(); as details) {
<div>
	<h3>Application Seat Management</h3>
	<p>Application Seat : {{ details.accSeatStatus }}</p>

	@if(details.canSeatBeRevoked){
	<common-button-row [center]="true">
		<button class="btn btn-danger mt-2" (click)="revokeSeat()">Revoke Seat</button>
	</common-button-row>
	}
</div>
}